import {ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges,} from '@angular/core';
import {MatDialog} from "@angular/material";
import {DocumentTemplateService} from "src/app/core/services/document-template.service";
import {SignatureConfigService} from "src/app/core/services/signature-config.service";
import {EnumRoleUser} from "src/app/core/constants/common"

@Component({
  selector: "app-signature-config-lot",
  templateUrl: "./signature-config-lot.component.html",
  styleUrls: ["./signature-config-lot.component.scss"],
})
export class SignatureConfigLotComponent implements OnInit, OnChanges {
  @Input('data') dataFootNote: any = [];
  @Input('create_side') createSide: any = null;
  @Input('disabled') disabled: boolean;
  @Input('isHaveDeleteCreata') isHaveDeleteCreata:boolean;
  isChanging: boolean = false;
  @Input('user_sign') userSign: string = null;
  @Input('DATA_RECORD_USER_PERFORM_SIGN') DATA_RECORD_USER_PERFORM_SIGN: any = [];

  @Input('maxNumberOfCustomerInFlow') maxNumberOfCustomerInFlow: number;

  // ẩn hàng chân ký khách hàng khi mẫu không có chân ký khách hàng (số lượng khách hàng = 0)
  @Input('hideCustomerRow') hideCustomerRow: boolean = false;

  listCustomerOrder = [];

  deleteCreateSide: boolean = false;
  deleteCreateSideWhenSubmit: boolean = false;

  constructor(
    private dialog: MatDialog,
    public signatureConfigService: SignatureConfigService,
    public documentTemplateService: DocumentTemplateService,
    public cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    if (this.dataFootNote) {
      this.dataFootNote.forEach(data => {
        let pages = [];
        data.signature.positions.map(sign => {
          if (!pages.includes(sign.page)) {
            pages.push(sign.page);
          }
        })
        data.signature.page = pages.join(', ');
      })
    }

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.dataFootNote) {
      this.deleteCreateSide =this.dataFootNote[(this.dataFootNote.length)-1].deleteCreateSide ? true : false
    }
    if (changes && changes.data && changes.data.currentValue) {
      this.dataFootNote = changes.data.currentValue;
    }
    if (changes && changes.createSide && changes.createSide.currentValue) {
      this.createSide = changes.createSide.currentValue;
    }

    if(changes && changes.DATA_RECORD_USER_PERFORM_SIGN && changes.DATA_RECORD_USER_PERFORM_SIGN.currentValue){
      // này là xóa cả bên lập thì xóa cả thằng phê duyệt
      if(changes.DATA_RECORD_USER_PERFORM_SIGN.currentValue.length <= 0){
        this.dataFootNote.forEach((item, index) => {
          if (item.signature &&
            item.signature.object
            && item.signature.object === "ENTERPRISEAPPROVER") {
            item.userId = null;
          }
        });
      }
    }

    this.listCustomerOrder = [];
    for (let i = 1; i <= this.maxNumberOfCustomerInFlow; i++) {
      this.listCustomerOrder.push({order:i, name: `khách hàng thứ ${i}`})
    }

    if(this.maxNumberOfCustomerInFlow == 1 && this.dataFootNote){
      this.dataFootNote.map((item, index) => {
        // nếu có 1 thằng khách hàng thôi thì map luôn chân ký cho thằng đầu tiên
        if (item.signature &&
          item.signature.object
          && item.signature.object === 'CUSTOMER') {
          console.log("customer", item);
          item.customerOrder = 1;
        }
      });
    }
    // mẫu không có chân ký khách hàng: bỏ mapping customerOrder (không có khách hàng nào để gán)
    if (this.maxNumberOfCustomerInFlow === 0 && this.dataFootNote) {
      this.dataFootNote.forEach((item) => {
        if (item.signature && item.signature.object === 'CUSTOMER') {
          item.customerOrder = null;
        }
      });
    }
  }
  selectedCustomerOrder: number;

  changeSelect(event: any, indexCurrent: number, newOrder: number) {
    this.isChanging = true;
    console.log("event", event, "indexCurrent", indexCurrent, "dataFootNote", this.dataFootNote, "newOrder", newOrder);

    if (event) {
      // this.dataFootNote.map((item, index) => {
      //   // tìm các thằng khác có cùng order, bỏ đi vì chỉ cho phép 1 khách hàng ỏ một chân ký thôi
      //   if (item.signature &&
      //     item.signature.object
      //     && item.signature.object === 'CUSTOMER'
      //     && newOrder == item.signature.customerOrder
      //     && index !== indexCurrent) {
      //     console.log(item);
      //     item.customer = null;
      //     item.customerOrder = null;
      //   }
      // });
    }
  }
  changeSelectApprover(event, data) {

    this.dataFootNote = this.dataFootNote.map(item => {
      if (item.signature && item.signature.signatureId && data.signature && data.signature.signatureId && item.signature.signatureId !== data.signature.signatureId) {
        if (item.userId === event) {
          item.userId = null;
        }
      }
      return item;
    });
  }
  checkDataApprover(data) {
    if (data.role === EnumRoleUser.USER_SIGN || !data.isSignDigitalCertificate || (data && data.signConfig && !data.signConfig.showImage)) {
      return true;
    } else {
      return false;
    }
  }
  checkDisableApprover(data) {
    const dataFilter = data.filter(res => res.isSignDigitalCertificate && (res && res.signConfig && res.signConfig.showImage));
    if (dataFilter.length > 0) {
      return false;
    } else {
      return true;
    }
  }
  // lisUserApprover = [];

  checkDataSelectedApprover(userId: string) {
    console.log(userId);
    // lấy danh sách chân phê duyệt
    // this.lisUserApprover = this.dataFootNote.filter(item=> (item.signature && item.signature.object && item.signature.object === 'ENTERPRISEAPPROVER'));

    const dataApprover = this.DATA_RECORD_USER_PERFORM_SIGN.filter((data) => data.userId === userId);
    if(dataApprover.length){
      return userId;
    }
    return null;
  }

}
